import { useNavigate } from "react-router-dom"

const useCommonfn = () => {
    const navigate=useNavigate()
    const navigateToDashBoard = () => {
        navigate("/dashboard")
    }
    return {
        navigateToDashBoard
    }
}

export default useCommonfn